import { bucketFor } from "../types/scoring";

/** Foreground color token for a 0–100 score, matching the prototype's
 * buckets (≥85 success, ≥70 warning, ≥50 neutral, <50 danger). UI-agnostic
 * — returns a CSS var reference; the consumer decides how to apply it. */
export function scoreColorVar(n: number): string {
  switch (bucketFor(n)) {
    case "excellent":
      return "var(--color-success-600)";
    case "good":
      return "var(--color-warning-600)";
    case "fair":
      return "var(--color-neutral-600)";
    case "poor":
      return "var(--color-danger-600)";
  }
}

/** Fill (bg) color for score bars — one step brighter than the text. */
export function scoreBgVar(n: number): string {
  switch (bucketFor(n)) {
    case "excellent":
      return "var(--color-success-500)";
    case "good":
      return "var(--color-warning-500)";
    case "fair":
      return "var(--color-neutral-400)";
    case "poor":
      return "var(--color-danger-500)";
  }
}

export function scoreColorStyle(n: number): { color: string } {
  return { color: scoreColorVar(n) };
}

export function scoreBgStyle(n: number): { background: string } {
  return { background: scoreBgVar(n) };
}
